import { Column, CreateDateColumn, Entity, OneToMany, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";

@Entity("soaking_sample_test")
export class SoakingSampleTest {

    @PrimaryGeneratedColumn("increment", { name: 'soaking_sample_test_id' })
        soakingSampleTestId: number;

    @Column({
        type: 'int',
        nullable: false,
        name: 'log_id'
    })
    logId: number;

    @Column({
        type: 'varchar',
        nullable: false,
        name: 'jobNumber'
    })
    jobNumber: string;
    
    @Column("varchar", {
    nullable: false,
    length: 250,
    name: "batchno_scode"
    })
    batchNoScode: string;

    
    @Column({
        type: 'int',
        nullable: false,
        name: 'bs_temp'
    })
    bsTemp: number;

    @Column({
        type: 'int',
        nullable: false,
        name: 'bs_count'
    })
    bsCount: number;

    @Column({
        type: 'int',
        nullable: false,
        name: 'bs_weight'
    })
    bsWeight: number;

    @Column({
        type: 'int',
        nullable: false,
        name: 'as_temp'
    })
    asTemp: number;

    @Column({
        type: 'int',
        nullable: false,
        name: 'as_count'
    })
    asCount: number;

    @Column({
        type: 'int',
        nullable: false,
        name: 'as_weight'
    })
    asWeight: number;

   

    @Column({
        type: 'int',
        nullable: false,
        name: 'chemical_consumptiona'
    })
    chemicalConsumptiona: number;

    @Column({
        type: 'int',
        nullable: false,
        name: 'chemical_consumptionB'
    })
    chemicalConsumptionb: number;

    @Column({
        type: 'datetime',
        nullable: false,
        name: 'time_in'
    })
    timeIn: Date;

    @Column({
        type: 'datetime',
        nullable: false,
        name: 'time_out'
    })
    timeOut: Date;

    @Column({
        type: 'int',
        nullable: false,
        name: 'pickup_percentage'
    })
    pickupPercentage: number;

   

    @Column("varchar", {
        nullable: false,
        length: 30,
        name: "remarks"
    })
    remarks: string;


    @CreateDateColumn({
        name: "created_at",
        type: "datetime"
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: false,
        name: "created_user",
        length: 50
    })
    createdUser: string | null;


    @UpdateDateColumn({
        name: "updated_at",
        type: 'datetime'
    })
    updatedAt: Date;

    @Column("varchar", {
        nullable: true,
        name: "updated_user",
        length: 50
    })
    updatedUser: string | null;


    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;

  
}